import React from 'react';
import { IoCloseSharp } from 'react-icons/io5';
import { useHistory } from 'react-router';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { PropsFromRedux } from '.';
import Select from '../form-controls/Select';
import { getRequiredErrorMessage } from '../../utils/common.utils';
import { SERVICE_CENTER } from '../../interfaces/shipping.interface';
import { useShippingFormContext } from '../../context/ShippingFormContext/context';
import { SHIPPING_FORM_TYPES } from '../../context/ShippingFormContext/reducer';
import { Spinner } from '../Spinners/Spinner';
import { USER } from '../../interfaces/auth.interface';

interface Props extends PropsFromRedux {}

const schema = yup.object().shape({
//   DestinationServiceCenterId: yup
//     .number()
//     .required(getRequiredErrorMessage('Service Center'))
//     .typeError('Service center must be selected'),
// });
DestinationServiceList: yup
.object()
.shape({
  IsActive: yup.boolean(),
  ServiceCentreId: yup.number(),
  Name: yup.string(),
})
.required(getRequiredErrorMessage('Destination ServiceCenter'))
.typeError('Service Center is required'),
});

interface Inputs {
  DestinationServiceCenterId: any;
}

const ServiceCenterModal: React.FC<Props> = ({
  user,
  hideModal,
  serviceCenters,
  getServiceCenters,
  serviceCentersByCountry,
  getServiceCentersByCountry
}) => {
  const history = useHistory();

  const userData: USER = user?.response?.Object;
  const { formState, dispatch } = useShippingFormContext();



  const { handleSubmit, register,control,  watch, errors } = useForm<Inputs>({
    resolver: yupResolver(schema),
  });

  const stationId: number = formState?.values?.ReceiverStationId;

  React.useEffect(() => {
    getServiceCenters(stationId);
  }, [getServiceCenters, stationId]);

  React.useEffect(() => {
    getServiceCentersByCountry(userData.Country.CountryId);
  }, [getServiceCentersByCountry, userData.Country.CountryId]);


  

  if (serviceCenters?.loading) {
    return (
      <div className="flex bg-white p-4 items-center justify-center">
        <Spinner color="#CCC" />
      </div>
    );
  }

  if (serviceCenters.error && !serviceCenters.loading) {
    return (
      <div className="flex bg-white p-4 flex-col items-center flex-wrap justify-center">
        <p>Could not fetch service centers.</p>
        <div className="mt-4">
          <button
            className="bg-secondary py-2 px-6 text-white rounded"
            type="button"
            aria-label="Retry"
            onClick={() => getServiceCenters()}
          >
            Try Again
          </button>
          <button
            className="border-secondary border py-2 px-6 text-secondary rounded"
            type="button"
            aria-label="Retry"
            onClick={() => hideModal()}
          >
            Close
          </button>
        </div>
      </div>
    );
  }

  const serviceCentersList : any = serviceCentersByCountry?.response?.Object;
  const selectedServiceCenter : any = watch('DestinationServiceList');

  const stateServiceCenters: SERVICE_CENTER[] =
    serviceCenters?.response?.Object;

  const onSubmit = ({ DestinationServiceCenterId }: Inputs) => {
    dispatch({
      type: SHIPPING_FORM_TYPES.UPDATE_VALUE,
      values: {
        DestinationServiceCenterId : selectedServiceCenter.ServiceCentreId,
      },
    });
    const redirectUrl = formState?.values?.PreShipmentItems?.length
      ? '/giggo-delivery-app/confirmation'
      : '/giggo-delivery-app/item-information';
    history.push(redirectUrl);
    hideModal();
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="w-full px-4 bg-white rounded-xl py-10 relative"
    >
      <button
        type="button"
        aria-label="Close"
        onClick={() => {
          hideModal();
        }}
      >
        <IoCloseSharp className="sticky sm:absolute cursor-pointer text-2xl top-0 left-full sm:left-auto sm:right-5 sm:top-5" />
      </button>

      <div className="w-full text-center mb-10">
        <h4 className="text-xl mb-5 font-bold">Select a service center</h4>
      </div>
      <div className="p-4 rounded-lg font-medium text-sm mb-2 bg-red-200 text-red-500">
        <p className="mb-3">
          Please note that the home delivery service is not enabled for your
          selected destination at the moment. To receive this item, the
          recipient will need to pick up from a service center selected by you{' '}
        </p>
        <p>
          Proceed to select a service center or{' '}
          <button
            className="font-bold underline"
            type="button"
            aria-label="go back"
            onClick={() => hideModal()}
          >
            Go Back
          </button>
        </p>
      </div>
{/* 
      <div className="w-full flex flex-wrap">
        {stateServiceCenters?.map((serviceCenter) => (
          <label
            className="sm:w-1/2 w-full p-2"
            htmlFor={`${serviceCenter.ServiceCentreId}`}
            key={serviceCenter.ServiceCentreId}
          >
            <div
              className={`bg-gray-100 cursor-pointer p-4 my-5 h-full rounded-lg ${
                selectedServiceCenter?.toString() ===
                serviceCenter.ServiceCentreId.toString()
                  ? 'font-bold bg-gray-300'
                  : ''
              }`}
            >
              <p className="font-medium mb-2">
                {serviceCenter.FormattedServiceCentreName}
              </p>
              <p className="text-sm">{serviceCenter.Address}</p>
            </div>
            <input
              id={`${serviceCenter.ServiceCentreId}`}
              name="DestinationServiceCenterId"
              value={serviceCenter.ServiceCentreId}
              className="hidden"
              ref={register}
              type="radio"
            />
          </label>
        ))}
      </div>
      <div className="w-full my-5">
        {errors['DestinationServiceCenterId'] ? (
          <span className="text-xs text-red-500">
            {errors['DestinationServiceCenterId'].message}
          </span>
        ) : (
          ''
        )}
      </div> */}


<div className="mb-5 my-6 text-sm text-gray-500 font-medium">
                <Controller
                    name="DestinationServiceList"
                    control={control}
                    defaultValue=""
                    render={({ name, value, onChange }) => (
                    <Select
                        name={name}
                        value={value}
                        id={name}
                        wrapperClassName="w-full"
                        valueKey="ServiceCentreId"
                        labelKey="Name"
                        label=""
                        labelClassName="mb-2 flex"
                        placeholder="Select service center"
                        customChange={onChange}
                        className="rounded-md"
                        options={serviceCentersList}
                    />
                    )}
                />
              </div>


      <div className="w-full my-10 flex items-center justify-center">
        <button
          className="h-12 flex justify-center bg-secondary rounded px-12 text-white items-center font-bold text-lg"
          type="submit"
        >
          Next
        </button>
      </div>
    </form>
  );
};

export default ServiceCenterModal;
